export function mapCheckInListRow(checkin) {
    const deliveryChallan = checkin.delivery_challan || {};
    const workSchedule = deliveryChallan.work_schedule || {};
    const salesOrderDetail = workSchedule.sales_order_detail || {};
    const salesOrder = salesOrderDetail.sales_order || {};
    const consignee = salesOrder.consignee || {};
    const customer = consignee.customer || {};

    return {
        id: checkin.id,
        checkout_no: checkin.checkout_no,
        delivery_challan_no: deliveryChallan.delivery_challan_no,
        delivery_challan_date: deliveryChallan.delivery_challan_date,
        order_no: salesOrder.order_no,
        customer_name: customer.name,
        consignee_name: consignee.name,
        grade: salesOrderDetail.product?.name,
        dc_qty: deliveryChallan.dc_qty,
        accepted_qty: checkin.accepted_qty,
        customer_status: checkin.customer_status || 'Waiting for checkin',
        cus_dc_status: checkin.cus_dc_status || 'Waiting for checkin',
        vehicle_no: deliveryChallan.vehicle?.name,
        driver_name: checkin.driver_name,
        hide_row_edit: checkin.customer_status ? 'No' : 'Yes',
        plant: workSchedule.plant?.alias_name,
    };
}
